import React, { useState } from 'react';
import styles from './Card.module.scss';
import PdfIcon from 'src/assets/icons/material-pdf.svg?react';
import DownloadIcon from 'src/assets/icons/mat-download.svg?react';
import PrintIcon from 'src/assets/icons/material_print.svg?react';
import { SllModule } from '@src/api/graphql-codegen';
import Button from '../button/Button';
import { downloadFile } from '@src/services/File';

type Props = {
  content: SllModule
  handleDownloadMaterial?: (content: SllModule) => void;
  handlePrintMaterial?: (content: SllModule) => void;
}

function SllMaterial(props: Props) {
  const { content, handleDownloadMaterial, handlePrintMaterial } = props

  const [downloading, setDownloading] = useState(false);

  const handleDownload = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (content.data) {
      setDownloading(true);
      downloadFile(content.data, 'pdf')
        .catch(() => {
          alert(`Can't download file.`);
        })
        .finally(() => {
          setDownloading(false);
        });
    }
  }

  const handlePrint = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    handlePrintMaterial?.(content)
  }

  const handleOpenMaterial = () => {
    handleDownloadMaterial?.(content)
  }

  return (
    <div className={styles.sllcard} onClick={handleOpenMaterial}>
      <PdfIcon />
      <div className={styles.title}>{content.name}</div>
      <Button label='' disabled={downloading} className={styles.printBtn} leftIcon={<PrintIcon className={styles.printIcon} />} onClick={handlePrint}/>
      <Button label='' disabled={downloading} className={styles.downloadBtn} leftIcon={<DownloadIcon />} onClick={handleDownload}/>
    </div>
  );
}

export default SllMaterial

